// export const serverApi = process.env.REACT_APP_API_URL;
export const serverApi = "https://merchantapi.amealio.com";
// export const serverApi = "https://uatmerchantapi.amealio.com";
// export const serverApi = "https://devapi.amealio.in";
// export const serverApi = 'http://localhost:443';
// export const socketIpAddress = "https://vendordashboard.amealio.in";

export const version = '1.8.66';

/******************************
 * @DESC GOOGLE API KEY
 *******************************/

export const GOOGLE_API_KEY = 'AIzaSyDdFnMqK0NlhvCJ2ejR_MlTOPNGbu8BhYQ';

export const PORTAL = 'MERCHANT';
export const imageUploadSize = '2097152';
export const videoUploadSize = '50485760';
export const shortvideosize = '681574400';
const LIVE_RAZOR = process.env.REACT_APP_RAZORPAY === 'true' ? true : false; //
export const ORDER_RAZORPAY_KEY = LIVE_RAZOR
  ? 'rzp_live_3mtYVO8nROb5Uq'
  : 'rzp_test_7P1z0w07gah1Uv';
export const EVENT_RAZORPAY_KEY = LIVE_RAZOR
  ? 'rzp_live_UTNgc4BjrA8YqJ'
  : 'rzp_test_7P1z0w07gah1Uv';
export const NEFT = 'NEFT';
export const IMPS = 'IMPS';

// SQUARE Image resolutions
export const SQUARE_IMG_MIN_DIME = 1024;
export const SQUARE_IMG_MAX_DIME = 1920;

// RECTANGLE Image resolutions
export const RECTANGLE_IMG_MIN_WIDTH = 1080;
export const RECTANGLE_IMG_MIN_HEIGHT = 720;

export const RECTANGLE_IMG_MAX_WIDTH = 1920;
export const RECTANGLE_IMG_MAX_HEIGHT = 1080;

// Video resolution
export const VIDEO_MIN_WIDTH = 1360;
export const VIDEO_MIN_HEIGHT = 768;

export const VIDEO_MAX_WIDTH = 1920;
export const VIDEO_MAX_HEIGHT = 1080;

export const ORDER_TOKEN_SECRET_KEY =
  'lasu#(*@BJHB#55asd$699as&&@!+56)(#$O$NBUUAS544';

export const VideoOptions = {
  settings: {
    autoplaySpeed: 3000,
    disableKeyboardControls: false,
    disablePanzoom: false,
    disableWheelControls: false,
    hideControlsAfter: 3000,
    lightboxTransitionSpeed: 0.6,
    lightboxTransitionTimingFunction: 'linear',
    overlayColor: 'rgba(0, 0, 0, 0.9)',
    slideAnimationType: 'fade',
    slideSpringValues: [300, 200],
    slideTransitionSpeed: 0.6,
    slideTransitionTimingFunction: 'linear',
  },
  buttons: {
    showAutoplayButton: false,
    showCloseButton: true,
    showDownloadButton: false,
    showFullscreenButton: false,
    showNextButton: false,
    showPrevButton: false,
    showThumbnailsButton: false,
  },
  caption: {
    showCaption: false,
  },
  thumbnails: {
    showThumbnails: false,
  },
  progressBar: {
    showProgressBar: false,
  },
};

//slider settings
export const SliderSettings = {
  arrows: true,
  infinite: false,
  speed: 500,
  slidesToShow: 6,
  slidesToScroll: 6,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      },
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};

export const deliveryConfig = {
  MERCHANT_CHARGE: 50,
  USER_CHARGE: 50,
  AMEALIO_CHARGE: 0,
  CANCEL_REFUND: 50,
};

//webapp url //

const apiToWebappUrlMap = {
  'https://uatmerchantapi.amealio.com': 'https://stage.amealio.com',
  'https://merchantapi.amealio.com': 'https://digital.amealio.com',
};

export const webappUrl = apiToWebappUrlMap[serverApi] || '';
